import React, { useEffect, useMemo } from "react";
import { GOOGLE_INSIGHT_LOADING } from "../../constants/loading.constant";
import { ANALYTICS_EXPAND } from "../../constants/modal.constant";
import { useAnalyticsCore } from "../../cores/analytics";
import { useGlobalCore } from "../../cores/globals";
import { useMeCore } from "../../cores/me";
import { useRouterCore } from "../../cores/router";
import { AnalyticsDatePicker } from "../component/analytics/AnalyticsDatePicker";
import { UpdateLoadingCard } from "../component/UpdateLoadingCard";
import { GooglenAnalyticsIcon } from "../component/social/GoogleAnalitycs/GoogleAnalitycsIcon";
import Content from "../layout/Content";
import { Header2 } from "../layout/Header2";
import Layout from "../layout/Layout";
import SideModal from "../layout/SideModal";
import { GoogleCharts } from "../component/analytics/GoogleCharts";
import moment from "moment";
import { useIntl } from "react-intl";

export const GoogleAnalytics = () => {
  const intl = useIntl();
  const { getGoogleInsights, date } = useAnalyticsCore();
  const {
    isLoading,
    isModal,
    turnOffModal,
    getModalContent,
    getModalVisibility,
  } = useGlobalCore();
  const {
    company,
    socialSettings,
    companyPlan,
    companyRole,
    isAdmin,
    isReseller,
  } = useMeCore();
  const { goToSocial } = useRouterCore();

  const isSync = useMemo(
    () => socialSettings && socialSettings.google,
    [socialSettings]
  );

  const isFutureDate = (date: string) => moment(date).isAfter(moment());

  const areDatesInverted = (since: string, until: string) =>
    moment(since).isAfter(moment(until));

  useEffect(() => {
    if (
      !isSync ||
      !companyPlan?.rules.allowAnalytics ||
      (!companyRole?.analitycs &&
        !companyRole?.owner &&
        !companyRole?.admin &&
        !companyRole?.agent &&
        !isAdmin &&
        !isReseller)
    )
      goToSocial();
  }, [goToSocial, isSync, companyPlan, companyRole, isAdmin, isReseller]);

  useEffect(() => {
    if (
      isSync &&
      !isFutureDate(date.since) &&
      !isFutureDate(date.until) &&
      !areDatesInverted(date.since, date.until)
    ) {
      getGoogleInsights(company!.id, date.since, date.until, "Daily");
      getGoogleInsights(company!.id, date.since, date.until, "Lifetime", 10);
    }
  }, [company, date, getGoogleInsights, isSync]);

  return (
    <Layout>
      <Header2
        title={intl.formatMessage({ id: "app.metricsGoogle.title" })}
        icon={<GooglenAnalyticsIcon active size="3x" />}
        rightChildren={<AnalyticsDatePicker />}
      />
      {isLoading(GOOGLE_INSIGHT_LOADING) ? (
        <UpdateLoadingCard
          loadingId={GOOGLE_INSIGHT_LOADING}
          text={intl.formatMessage({ id: "app.metricsGoogle.updating" })}
        />
      ) : (
        <Content>
          <GoogleCharts />
        </Content>
      )}
      <SideModal
        active={isModal(ANALYTICS_EXPAND)}
        visible={getModalVisibility(ANALYTICS_EXPAND)}
        onClose={() => turnOffModal(ANALYTICS_EXPAND)}
        left
      >
        {getModalContent(ANALYTICS_EXPAND)}
      </SideModal>
    </Layout>
  );
};
